export enum VariationFormat {
  Wide_30s = 'Wide_30s',
  Wide_15s = 'Wide_15s',
  Wide_5s = 'Wide_05s',
  Tall_15s = 'Tall_15s',
  Tall_5s = 'Tall_05s',
}

export enum UserVideoOmniType {
  OmniCutdown = 'omni_cutdown',
  OmniTranslation = 'omni_translation',
  OmniABTest = 'omni_ab_test',
}

export type VariationAspectRatio = '16:9' | '4:5';
